import { get, post } from './base'

const WEB_CONFIG_PATH = '/web_config'

type WebsiteConfigRow = {
  key: string
  value: string
}

export const fetchConfig = () => {
  return get('config')
}

async function fetchWebConfigByKey(
  key: string,
): Promise<WebsiteConfigRow | null> {
  try {
    const res = await get<WebsiteConfigRow>(
      WEB_CONFIG_PATH,
      { params: { key } },
      { silent: true },
    )
    return res ?? null
  }
  catch {
    return null
  }
}

export async function getWebsiteLogoConfig(): Promise<WebsiteConfigRow | null> {
  return fetchWebConfigByKey('logo')
}

export async function getWebsiteLatestConfig(
  key: string,
): Promise<WebsiteConfigRow | null> {
  return fetchWebConfigByKey(key)
}

export async function getWebsiteFaviconConfig(): Promise<WebsiteConfigRow | null> {
  return fetchWebConfigByKey('favicon')
}

export async function getWebsiteTitleConfig(): Promise<WebsiteConfigRow | null> {
  return fetchWebConfigByKey('title')
}

export async function getWebsiteConfig(): Promise<WebsiteConfigRow | null> {
  try {
    const res = await get<WebsiteConfigRow>(WEB_CONFIG_PATH, {}, { silent: true })
    return res?.key ? res : null
  }
  catch {
    return null
  }
}

export async function updateWebsiteConfig(payload: {
  key: string
  value: string
}) {
  return post<WebsiteConfigRow>(WEB_CONFIG_PATH, { body: payload })
}
